exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification h2[data-v-bdfa0cf4],h3[data-v-bdfa0cf4]{color:#393e44;font-size:100%}.notification h2[data-v-bdfa0cf4]{font-weight:700}", ""]);

// exports
